<template>
  <div class="text-left">
    <div class="mb-4">
      <div
        class="text-left custom-control custom-checkbox"
        :class="{ 'is-invalid': $v.personalDataAgreement.$error }"
      >
        <v-checkbox
          v-model="$v.personalDataAgreement.$model"
          :error="$v.personalDataAgreement.$error"
          class="mt-2"
          hide-details="auto"
          @change="updateValue"
          @click="sendGtmEvent('Souhlas se zpracováním osobních údajů')"
        >
          <template #label>
            <template v-if="formName === 'AeskuLab'">
              <i18n path="aeskulab.form.personalData.text">
                <template #link>
                  <span
                    class="link--inline"
                    @click.prevent.stop="$eventHub.$emit(`openPrivacyPolicyModal_${inputData.id}`)"
                    >{{ $t('aeskulab.form.personalData.link') }}</span
                  >
                </template>
              </i18n>
            </template>
            <template v-else>
              <div>
                {{ $t('dataProcessing.iAgree') }}&nbsp;
                <span
                  class="link--inline"
                  @click.prevent.stop="$eventHub.$emit(`openPrivacyPolicyModal_${inputData.id}`)"
                  >{{ $t('dataProcessing.privacyPolicy') }}</span
                >
              </div>
            </template>
          </template>
        </v-checkbox>
      </div>
    </div>

    <DynamicPrivacyPolicyModal
      v-if="$te(`${formLangKey}.agreements.privacyPolicy`, $i18n.locale)"
      :content-idx="`${formLangKey}.agreements.privacyPolicy`"
    />
    <DocumentModal
      v-else
      :identifier="inputData.id"
      name="privacyPolicy"
      :category="category"
      type-name="personal_data_processing"
    />
  </div>
</template>

<script>
import { checked } from '@/customVuelidate';
import formGtm from '@/mixins/formGtm';
import { mapGetters } from 'vuex';

export default {
  name: 'UlPersonalDataAgreement',
  mixins: [formGtm],
  props: {
    inputData: {
      type: Object,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      personalDataAgreement: false
    };
  },
  validations: {
    personalDataAgreement: { checked }
  },
  methods: {
    updateValue() {
      this.$v.$touch();
      this.$store.commit('dynamicForms/updateValidation', {
        id: this.inputData.id,
        value: !this.$v.$invalid,
        formName: this.formName
      });
      this.$store.dispatch('dynamicForms/updateResponse', {
        id: this.inputData.id,
        value: this.$v.personalDataAgreement.$model,
        formName: this.formName
      });
    }
  },
  computed: {
    ...mapGetters({
      formLangKey: 'thematicCounselling/formLangKey'
    }),
    responses() {
      return this.$store.getters[`dynamicForms/responses`];
    },
    category() {
      let category = 'default';
      if (this.isUlHc) {
        category = 'aeskulab';
      } else if (this.isPutinSucks) {
        category = 'ukrajina';
      }
      return category;
    }
  },
  created() {
    this.$v.personalDataAgreement.$model =
      this.responses[this.formName][this.inputData.id] || false;
    this.$v.$reset();
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => {
      this.$v.$touch();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
  }
};
</script>
